import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JeeSession1Service {
 
  jwt=
  'eyJhbGciOiJIUzUxMiJ9.eyJkZXZpY2VTZXNzaW9uSWQiOiJ3NHdHYVdEY0UxVGVsbUJlSWhtczN6V2IwRU80bTRMeDhXZlp3RGQ1NWM5N25TbVlCJTJGMmdmSW1OeGxKcVN0ZWEiLCJ0b2tlblJlZnJlc2hLZXkiOiJtYXRMZjI4RHQlMkJYMnNvSyUyQjhwdSUyRlBiMDlMdzdKUXFoRVFwQmRvTFdPZjBrRjFOb0Y3M1RvZ1I4NDVCNWF0SUtaIiwiY2FtcHVzSWQiOjEwOCwicGF5cm9sbElkIjoiSFlEMTEwMDA1Nzc5IiwidXNlck5hbWUiOiJSQUpBSyBQQVNIQSBTIiwiZXhwIjoxNzcwMDk1OTU3LCJ1c2VySWQiOiJIWUQxMTAwMDU3NzkiLCJpYXQiOjE3NzAwMDk1NTcsInVuaXF1ZUlkIjo0MzUyOTgsInBsYXRmb3JtIjoiYXBwIiwianRpIjoiMDEwZjk5MzgtNTlhMC00ZDAwLWEwZTEtZThhZTE5MmFjNjIyIn0.o6owzFpnaQNU6vMiwQQ2PTueAOp0AKwa5OCJohCCXnhDe_254rnqpM4qyjCMRzCWXijhWrG06iNT7rewirj0iA'
  constructor(private http:HttpClient) {
   }
  getAdmNo(searchCriteria: string) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  const groupName = 'M.P.C'; // statically set
  const url = environment.masterDomain +`/employee/api/jwtV2/admNoSearch` +
              `?searchCriteria=${encodeURIComponent(searchCriteria)}` +
              `&groupName=${encodeURIComponent(groupName)}`;
  return this.http.get(url, { headers });
}

getStudentList(admNo: string) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const mainSession = 'JeeMainsSession1';
  const url = environment.masterDomain +`/employee/api/jwtV2/jeemains/admNoWiseStudentList` +
              `?admNo=${encodeURIComponent(admNo)}` +
              `&mainSession=${encodeURIComponent(mainSession)}` ;
  return this.http.get(url, { headers });
}

getCategoryList() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  const url = environment.masterDomain +`/employee/api/jwtV2/categoryList`;
  return this.http.get<any[]>(url, { headers });
}

 


private url = environment.masterDomain +'/employee/api/jwtV2/saveJeeMainsDetails';
  createStudent(studentData: any) {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.jwt}`,
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(this.url, studentData, { headers });
  }


  getEnteredDta() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  // Get current date in YYYY-MM-DD format
  const today = new Date();
  const createdOn = today.toISOString().split('T')[0]; // "2025-07-24"
  const url = environment.masterDomain +`/employee/api/jwtV2/jeeMainsEnteredList` +
              `?createdOn=${encodeURIComponent(createdOn)}`;

  return this.http.get<any[]>(url, { headers });
}

getEntereyDta() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });

 const examYear = '2026'; 
  const url = environment.masterDomain +`/employee/api/jwtV2/jeeMains1EntryList` +
              `?examYear=${encodeURIComponent(examYear)}`;
  return this.http.get<any[]>(url, { headers });
}

getNotAppliedStudents(programName:any) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const examYear = '2026';

 //const programName = 'Sr_NEON';
  const url = environment.masterDomain +`/employee/api/jwtV2/jeeMains1NotEnteredList` +
              `?programName=${encodeURIComponent(programName)}`+
              `&examYear=${encodeURIComponent(examYear)}`;
  return this.http.get<any[]>(url, { headers });

}




//SESSION-2

getjee2StudentList(admNo: string) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const mainSession = 'JeeMainsSession2';
  const url = environment.masterDomain +`/employee/api/jwtV2/jeemains/admNoWiseStudentList` +
              `?admNo=${encodeURIComponent(admNo)}` +
              `&mainSession=${encodeURIComponent(mainSession)}` ;
  return this.http.get(url, { headers });
}


getJee2EnteredDta() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  const today = new Date();
  const createdOn = today.toISOString().split('T')[0];
  const url = environment.masterDomain +`/employee/api/jwtV2/jeeMains2EnteredList?createdOn=${encodeURIComponent(createdOn)}`;
  console.log(' API URL:', url);
  return this.http.get<any[]>(url, { headers });
}

getJee2EntereyDta() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const examYear = '2026';
  const url = environment.masterDomain +`/employee/api/jwtV2/jeeMains2EntryList` +
              `?examYear=${encodeURIComponent(examYear)}`;
  return this.http.get<any[]>(url, { headers });
}

getNotAppliedjee2Students(programName:any) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const examYear = '2025';
  const url = environment.masterDomain +`/employee/api/jwtV2/jeeMainsNotEnteredList` +
              `?programName=${encodeURIComponent(programName)}`+
              `&examYear=${encodeURIComponent(examYear)}`;
  return this.http.get<any[]>(url, { headers });

}



//ROOKIE END POINTS


 getRookieAdmNo(searchCriteria: string) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  const url = environment.masterDomain +`/employee/api/jwtV2/rookieAdmNoSearch` +
              `?searchCriteria=${encodeURIComponent(searchCriteria)}`;
  return this.http.get(url, { headers });
}

getRookieStudentList(admNo: string) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const mainSession = 'RookieJeeMainsSession1';
  const url = environment.masterDomain +`/employee/api/jwtV2/rookie/admNoWiseStudentList` +
              `?admNo=${encodeURIComponent(admNo)}` +
              `&mainSession=${encodeURIComponent(mainSession)}` ;
  return this.http.get(url, { headers });
}


private rookieStudentData = environment.masterDomain +'/employee/api/jwtV2/saveRookieJeeMainsDetails';
  createRookieStudent(rookieStudentData: any) {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.jwt}`,
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(this.rookieStudentData, rookieStudentData, { headers });
  }

  getRookieEnteredDta() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  const today = new Date();
  const createdOn = today.toISOString().split('T')[0];
  const url = environment.masterDomain +`/employee/api/jwtV2/rookieJeeMainsEnteredList?createdOn=${encodeURIComponent(createdOn)}`;
  console.log(' API URL:', url);
  return this.http.get<any[]>(url, { headers });
}

getJeeRookieEntereyData() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const examYear = '2026'; 
  const url = environment.masterDomain +`/employee/api/jwtV2/RookieJeeMainsEnteryList` +
              `?examYear=${encodeURIComponent(examYear)}`;
  return this.http.get<any[]>(url, { headers });
}


getNotAppliedRookieStudents(programName:any) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const examYear = '2026';
  const url = environment.masterDomain +`/employee/api/jwtV2/jeeMainsRookie1NotEnteredList` +
              `?programName=${encodeURIComponent(programName)}`+
              `&examYear=${encodeURIComponent(examYear)}`;
  return this.http.get<any[]>(url, { headers });
}
//rookie2 session

getJeeRookie2EntereyDta() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });

 const examYear = '2026';
  const url = environment.masterDomain +`/employee/api/jwtV2/RookieJeeMains2EnteryList` +
              `?examYear=${encodeURIComponent(examYear)}`;
  return this.http.get<any[]>(url, { headers });
}


  getRookie2EnteredDta() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  const today = new Date();
  const createdOn = today.toISOString().split('T')[0];
  const url = environment.masterDomain +`/employee/api/jwtV2/rookieJeeMains2EnteredList?createdOn=${encodeURIComponent(createdOn)}`;
  console.log(' API URL:', url);
  return this.http.get<any[]>(url, { headers });
}

getRookie2StudentList(admNo: string) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const mainSession = 'RookieJeeMainsSession2';
  const url = environment.masterDomain +`/employee/api/jwtV2/rookie/admNoWiseStudentList` +
              `?admNo=${encodeURIComponent(admNo)}` +
              `&mainSession=${encodeURIComponent(mainSession)}` ;
  return this.http.get(url, { headers });
}

//neet hlt entry

 getNeetAdmNo(searchCriteria: string) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  const groupName = 'M.P.C'; // statically set
  const url = environment.masterDomain +`/employee/api/jwtV2/neet/admNoSearch` +
              `?searchCriteria=${encodeURIComponent(searchCriteria)}`;
  return this.http.get(url, { headers });
}

getNeetStudentList(admNo: string) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  const url = environment.masterDomain +`/employee/api/jwtV2/neet/admNoWiseStudentList` +
              `?admNo=${encodeURIComponent(admNo)}`;
  return this.http.get(url, { headers });
}


private neet = environment.masterDomain +'/employee/api/jwtV2/saveNeetDetails';
  createNeetStudent(studentData: any) {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.jwt}`,
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(this.neet, studentData, { headers });
  }

   getNeetEnteredData() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  // Get current date in YYYY-MM-DD format
  const today = new Date();
  const createdOn = today.toISOString().split('T')[0]; // "2025-07-24"
  const url = environment.masterDomain +`/employee/api/jwtV2/neetMainsEnteredList` +
              `?createdOn=${encodeURIComponent(createdOn)}`;

  return this.http.get<any[]>(url, { headers });
}

getNeetEntereyDta() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const examYear = '2026';
  const url = environment.masterDomain +`/employee/api/jwtV2/neetEntryList` +
              `?examYear=${encodeURIComponent(examYear)}`;
  return this.http.get<any[]>(url, { headers });
}

getNotAppliedNeetStudents(programName:any) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const examYear = '2026';
  const url = environment.masterDomain +`/employee/api/jwtV2/NeetNotEnteredList` +
              `?programName=${encodeURIComponent(programName)}`+
              `&examYear=${encodeURIComponent(examYear)}`;
  return this.http.get<any[]>(url, { headers });

}

// NEET ROOKIE

getNeetRookieAdmNo(searchCriteria: string) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  const url = environment.masterDomain +`/employee/api/jwtV2/neetRookie/admNoSearch` +
              `?searchCriteria=${encodeURIComponent(searchCriteria)}`;
  return this.http.get(url, { headers });
}

getNeetRookieStudentList(admNo: string) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  const url = environment.masterDomain +`/employee/api/jwtV2/neetRookie/admNoWiseStudentList` +
              `?admNo=${encodeURIComponent(admNo)}`;
  return this.http.get(url, { headers });
}

 getNeetRookieEnteredData() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
  // Get current date in YYYY-MM-DD format
  const today = new Date();
  const createdOn = today.toISOString().split('T')[0]; // "2025-07-24"
  const url = environment.masterDomain +`/employee/api/jwtV2/neetRookieEnteredList` +
              `?createdOn=${encodeURIComponent(createdOn)}`;

  return this.http.get<any[]>(url, { headers });
}

getNeetRookieEntereyDta() {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const examYear = '2026';
  const url = environment.masterDomain +`/employee/api/jwtV2/neetRookieEntryList` +
              `?examYear=${encodeURIComponent(examYear)}`;
  return this.http.get<any[]>(url, { headers });
}

private neetRookie = environment.masterDomain +'/employee/api/jwtV2/saveNeetRookieDetails';
  createNeetRookieStudent(studentData: any) {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.jwt}`,
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(this.neetRookie, studentData, { headers });
  }



  getNotAppliedNeetRookieStudents(programName:any) {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.jwt}`
  });
 const examYear = '2026';
  const url = environment.masterDomain +`/employee/api/jwtV2/neetRookieNotEnteredList` +
              `?programName=${encodeURIComponent(programName)}`+
              `&examYear=${encodeURIComponent(examYear)}`;
  return this.http.get<any[]>(url, { headers });

}

}
